import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import numeral from 'numeral';
import { BigNumber } from 'bignumber.js';
import { Colors } from '../constants';

const Row = styled.div`
  display: flex;
  height: 60px;
  margin-bottom: 2px;
  background: ${props => props.theme.fav.rowBg};
  &:last-child {
    margin-bottom: 0;
  }
`;

const Left = styled.div`
  flex: 1;
  padding: 3px 0 3px 5px;
`;
const Right = styled.div`
  flex: 1;
  padding: 3px 5px 3px 0;
`;

const Symbol = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 14px;
`;

const Price = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 20px;
  padding-top: 2px;
  margin-bottom: -2px;
`;

const Diff = styled.span`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

const DiffPercent = styled.span`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

const StatTitle = styled.span`
  color: ${props => props.theme.fav.stat};
  font-size: 12px;
`;

const StatLine = styled.div`
  color: ${props => props.theme.fav.text};
  padding-top: 1px;
  font-size: 12px;
`;

const FavRowY = ({
  theme,
  coin: {
    symbol,
    quotes: {
      BTC: { price, percent_change_24h: diffPercent },
    },
    // symbol, price, diff, diffPercent, market, high, low, vol,
  },
}) => {
  console.log('hi');
  // const priceUSD = BigNumber(price).times(10500);
  // const priceUSDFmt = numeral(priceUSD).format('$0,0.00');
  // const priceExtra = symbol !== 'BTC' ? ` - ${priceUSDFmt}` : '';
  return (
    <ThemeProvider theme={theme}>
      <Row>
        <Left>
          <Symbol>{symbol}</Symbol>
          <Price>{price}</Price>
          <div>
            <DiffPercent value={+diffPercent}>{diffPercent}%</DiffPercent>
          </div>
        </Left>
      </Row>
      {/* <Row>
        <Left>
          <Symbol>
            {symbol}
            {priceExtra}
          </Symbol>
          <Price>{price}</Price>
          <div>
            <Diff value={+diff}>{diff}</Diff> <DiffPercent value={+diffPercent}>{diffPercent}%</DiffPercent>
          </div>
        </Left>
        <Right>
          <StatLine>{market}</StatLine>
          <StatLine>
            <StatTitle>HIGH: </StatTitle>
            {high}
          </StatLine>
          <StatLine>
            <StatTitle>LOW: </StatTitle>
            {low}
          </StatLine>
          <StatLine>
            <StatTitle>24H VOLUME: </StatTitle>
            {vol}
          </StatLine>
        </Right>
      </Row> */}
    </ThemeProvider>
  );
};

export default withTheme(FavRowY);



// WEBPACK FOOTER //
// ./src/components/FavRowY.js